import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

interface NewsArticle {
  id: string;
  title: string;
  category: string;
  date: string;
  excerpt: string;
  image: string;
  slug: string;
}

const newsArticles: NewsArticle[] = [
  {
    id: '1',
    title: 'Smart Manufacturing Trends and Implementation',
    category: 'Technology',
    date: 'June 17, 2025',
    excerpt: 'Exploring the latest trends in smart manufacturing and how HI-TAK is leading the way in implementing cutting-edge technologies for precision machining.',
    image: 'https://public.readdy.ai/ai/img_res/36dc5afc4dd2154ea634cdfe2ccfbf11.jpg',
    slug: 'smart-manufacturing-trends-implementation'
  },
  {
    id: '2',
    title: 'New Gun Drilling System Achieves L/D400 Breakthrough',
    category: 'Product Launch',
    date: 'May 28, 2025',
    excerpt: 'HI-TAK announces breakthrough in deep hole drilling technology with new system capable of achieving unprecedented L/D400 ratios with exceptional precision.',
    image: 'https://readdy.ai/api/search-image?query=Precision%20gun%20drilling%20machine%20with%20advanced%20spindle%20system%20drilling%20deep%20holes%20in%20metal%20workpiece%20with%20coolant%20flow%20in%20modern%20manufacturing%20facility%20with%20teal%20accent%20lighting&width=800&height=500&seq=news2&orientation=landscape',
    slug: 'gun-drilling-ld400-breakthrough'
  },
  {
    id: '3',
    title: 'Partnership with Leading Medical Device Manufacturer',
    category: 'Business',
    date: 'May 15, 2025',
    excerpt: 'HI-TAK expands its presence in the medical device industry through strategic partnership, delivering precision drilling solutions for next-generation surgical instruments.',
    image: 'https://readdy.ai/api/search-image?query=Medical%20device%20manufacturing%20facility%20with%20precision%20surgical%20instruments%20and%20implants%20being%20machined%20on%20advanced%20equipment%20in%20sterile%20clean%20room%20environment%20with%20white%20and%20teal%20lighting&width=800&height=500&seq=news3&orientation=landscape',
    slug: 'medical-device-partnership'
  },
  {
    id: '4',
    title: 'Sustainability Initiative: Reducing Manufacturing Waste',
    category: 'Sustainability',
    date: 'April 22, 2025',
    excerpt: 'HI-TAK launches comprehensive sustainability program focused on reducing manufacturing waste and energy consumption while maintaining precision standards.',
    image: 'https://readdy.ai/api/search-image?query=Eco-friendly%20manufacturing%20facility%20with%20green%20technology%20solar%20panels%20recycling%20systems%20and%20sustainable%20production%20processes%20in%20modern%20industrial%20setting%20with%20natural%20lighting&width=800&height=500&seq=news4&orientation=landscape',
    slug: 'sustainability-initiative'
  },
  {
    id: '5',
    title: 'Aerospace Industry Certification Achievement',
    category: 'Achievement',
    date: 'April 8, 2025',
    excerpt: 'HI-TAK receives prestigious aerospace industry certification, opening new opportunities for supplying precision drilling systems to aircraft manufacturers.',
    image: 'https://readdy.ai/api/search-image?query=Aerospace%20manufacturing%20facility%20with%20aircraft%20engine%20components%20and%20precision%20machined%20parts%20on%20advanced%20drilling%20equipment%20with%20metallic%20surfaces%20and%20professional%20lighting&width=800&height=500&seq=news5&orientation=landscape',
    slug: 'aerospace-certification'
  },
  {
    id: '6',
    title: 'Advanced Training Program for Operators',
    category: 'Education',
    date: 'March 25, 2025',
    excerpt: 'New comprehensive training program launched to help operators maximize the potential of HI-TAK gun drilling systems with hands-on workshops and certification.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20training%20workshop%20with%20instructors%20teaching%20operators%20on%20gun%20drilling%20machines%20with%20digital%20screens%20and%20training%20materials%20in%20modern%20educational%20facility&width=800&height=500&seq=news6&orientation=landscape',
    slug: 'operator-training-program'
  },
  {
    id: '7',
    title: 'Automotive Industry Success Story',
    category: 'Case Study',
    date: 'March 10, 2025',
    excerpt: 'Major automotive manufacturer achieves 40% productivity increase using HI-TAK gun drilling systems for fuel injection component production.',
    image: 'https://readdy.ai/api/search-image?query=Automotive%20manufacturing%20plant%20with%20engine%20components%20fuel%20injection%20parts%20and%20precision%20machined%20automotive%20parts%20on%20production%20line%20with%20industrial%20lighting&width=800&height=500&seq=news7&orientation=landscape',
    slug: 'automotive-success-story'
  },
  {
    id: '8',
    title: 'R&D Investment in Next-Gen Drilling Technology',
    category: 'Innovation',
    date: 'February 18, 2025',
    excerpt: 'HI-TAK announces significant R&D investment to develop next-generation drilling technologies for emerging industries and materials.',
    image: 'https://readdy.ai/api/search-image?query=Research%20and%20development%20laboratory%20with%20engineers%20testing%20advanced%20drilling%20technology%20prototypes%20and%20analyzing%20data%20on%20computer%20screens%20in%20modern%20tech%20facility%20with%20teal%20accents&width=800&height=500&seq=news8&orientation=landscape',
    slug: 'rd-investment-announcement'
  },
  {
    id: '9',
    title: 'International Expansion into European Markets',
    category: 'Business',
    date: 'January 30, 2025',
    excerpt: 'HI-TAK establishes new European distribution network to better serve growing demand for precision gun drilling systems in the region.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20European%20industrial%20facility%20with%20HI-TAK%20machinery%20and%20international%20business%20professionals%20in%20contemporary%20office%20and%20manufacturing%20space%20with%20global%20connectivity%20theme&width=800&height=500&seq=news9&orientation=landscape',
    slug: 'european-expansion'
  }
];

const categories = ['All', 'Technology', 'Product Launch', 'Business', 'Sustainability', 'Achievement', 'Education', 'Case Study', 'Innovation'];

export default function News() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');

  const filteredArticles = newsArticles.filter(article => {
    const matchesCategory = selectedCategory === 'All' || article.category === selectedCategory;
    const matchesSearch = article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         article.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#001E3C] via-[#002D5C] to-[#001E3C]">
        <div className="max-w-7xl mx-auto text-center">
          <span className="inline-block px-4 py-2 bg-[#00D9C9]/10 text-[#00D9C9] rounded-full text-sm font-semibold border border-[#00D9C9]/20 mb-6">
            Latest Updates
          </span>
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
            News & Stories
          </h1>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Stay informed about HI-TAK's latest innovations, partnerships, and industry insights
          </p>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-6 items-center justify-between">
            {/* Search Bar */}
            <div className="relative w-full lg:w-96">
              <input
                type="text"
                placeholder="Search articles..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full px-5 py-3 pl-12 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#00D9C9] focus:border-transparent text-sm"
              />
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl w-5 h-5 flex items-center justify-center"></i>
            </div>

            {/* Category Filter */}
            <div className="flex flex-wrap gap-3 justify-center">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-[#00D9C9] text-[#001E3C]'
                      : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-300'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {filteredArticles.length === 0 ? (
            <div className="text-center py-20">
              <i className="ri-file-search-line text-6xl text-gray-300 mb-4"></i>
              <p className="text-xl text-gray-500">No articles found matching your criteria</p>
            </div>
          ) : (
            <>
              {/* Featured Article */}
              <Link
                to={`/news/${filteredArticles[0].slug}`}
                className="group block mb-16 bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200"
              >
                <div className="grid lg:grid-cols-2 gap-0">
                  <div className="relative h-[400px] lg:h-auto overflow-hidden">
                    <img
                      src={filteredArticles[0].image}
                      alt={filteredArticles[0].title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-6 left-6">
                      <span className="px-4 py-2 bg-[#00D9C9] text-[#001E3C] rounded-full text-sm font-bold">
                        Featured
                      </span>
                    </div>
                  </div>
                  <div className="p-10 lg:p-14 flex flex-col justify-center">
                    <div className="flex items-center gap-4 mb-4">
                      <span className="px-3 py-1 bg-[#00D9C9]/10 text-[#00D9C9] rounded-full text-sm font-semibold">
                        {filteredArticles[0].category}
                      </span>
                      <span className="text-gray-500 text-sm">{filteredArticles[0].date}</span>
                    </div>
                    <h2 className="text-3xl lg:text-4xl font-bold text-[#001E3C] mb-4 group-hover:text-[#00D9C9] transition-colors duration-300">
                      {filteredArticles[0].title}
                    </h2>
                    <p className="text-gray-600 text-lg leading-relaxed mb-6">
                      {filteredArticles[0].excerpt}
                    </p>
                    <div className="flex items-center gap-2 text-[#00D9C9] font-bold group-hover:gap-4 transition-all duration-300">
                      Read Full Article
                      <i className="ri-arrow-right-line text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                  </div>
                </div>
              </Link>

              {/* Article Grid */}
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredArticles.slice(1).map((article) => (
                  <Link
                    key={article.id}
                    to={`/news/${article.slug}`}
                    className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200 flex flex-col"
                  >
                    <div className="relative h-[240px] overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6 flex flex-col flex-grow">
                      <div className="flex items-center gap-3 mb-3">
                        <span className="px-3 py-1 bg-[#00D9C9]/10 text-[#00D9C9] rounded-full text-xs font-semibold">
                          {article.category}
                        </span>
                        <span className="text-gray-500 text-xs">{article.date}</span>
                      </div>
                      <h3 className="text-xl font-bold text-[#001E3C] mb-3 group-hover:text-[#00D9C9] transition-colors duration-300">
                        {article.title}
                      </h3>
                      <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-grow">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center gap-2 text-[#00D9C9] font-bold text-sm group-hover:gap-3 transition-all duration-300">
                        Read More
                        <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#001E3C] via-[#002D5C] to-[#001E3C]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Stay Updated with HI-TAK News
          </h2>
          <p className="text-xl text-white/80 mb-10">
            Subscribe to our newsletter and never miss important updates about our innovations and industry insights
          </p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
            <input
              type="email"
              placeholder="Enter your email address"
              className="flex-1 px-6 py-4 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#00D9C9]"
            />
            <button className="bg-[#00D9C9] text-[#001E3C] px-8 py-4 rounded-xl font-bold hover:bg-[#00F5E0] transition-all duration-300 whitespace-nowrap cursor-pointer">
              Subscribe Now
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
